var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "editCatForm",
          attrs: {
            model: _vm.editCatForm,
            rules: _vm.editCatFormRules,
            "label-width": "120px"
          }
        },
        [
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "基本信息", name: "first" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "名字", prop: "name" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.editCatForm.name,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "name", $$v)
                            },
                            expression: "editCatForm.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "性别", prop: "sex" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "选择性别" },
                            model: {
                              value: _vm.editCatForm.sex,
                              callback: function($$v) {
                                _vm.$set(_vm.editCatForm, "sex", $$v)
                              },
                              expression: "editCatForm.sex"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "公", value: "公" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "母", value: "母" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "生日", prop: "birthday" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                placeholder: "选择 年/月/日"
                              },
                              model: {
                                value: _vm.editCatForm.birthday,
                                callback: function($$v) {
                                  _vm.$set(_vm.editCatForm, "birthday", $$v)
                                },
                                expression: "editCatForm.birthday"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "品种 & 标签", prop: "tags" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { multiple: "", placeholder: "请选择" },
                            model: {
                              value: _vm.editCatForm.tags,
                              callback: function($$v) {
                                _vm.$set(_vm.editCatForm, "tags", $$v)
                              },
                              expression: "editCatForm.tags"
                            }
                          },
                          _vm._l(_vm.tags, function(tag) {
                            return _c("el-option", {
                              key: tag.id,
                              attrs: { label: tag.tag, value: tag.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "简介", prop: "intro" } },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.editCatForm.intro,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "intro", $$v)
                            },
                            expression: "editCatForm.intro"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "上架状态", prop: "status" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "上架状态" },
                            model: {
                              value: _vm.editCatForm.status,
                              callback: function($$v) {
                                _vm.$set(_vm.editCatForm, "status", $$v)
                              },
                              expression: "editCatForm.status"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "可预订", value: "可预订" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "可售卖", value: "可售卖" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "种猫-非卖", value: "种猫-非卖" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "下架", value: "下架" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否为精选" } },
                      [
                        _c("el-switch", {
                          model: {
                            value: _vm.editCatForm.recommend,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "recommend", $$v)
                            },
                            expression: "editCatForm.recommend"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "图片视频", name: "second" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "封面图", prop: "banner_img" } },
                      [
                        _c("Upload", {
                          attrs: {
                            reportType: "banner_img",
                            file_url: _vm.editCatForm.banner_img
                          },
                          on: { success: _vm.handleUploadFileSuccess }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          model: {
                            value: _vm.editCatForm.banner_img,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "banner_img", $$v)
                            },
                            expression: "editCatForm.banner_img"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "正面图" } },
                      [
                        _c("Upload", {
                          attrs: {
                            reportType: "face_img",
                            file_url: _vm.editCatForm.face_img
                          },
                          on: { success: _vm.handleUploadFileSuccess }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          model: {
                            value: _vm.editCatForm.face_img,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "face_img", $$v)
                            },
                            expression: "editCatForm.face_img"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "出生图" } },
                      [
                        _c("Upload", {
                          attrs: {
                            reportType: "birth_img",
                            file_url: _vm.editCatForm.birth_img
                          },
                          on: { success: _vm.handleUploadFileSuccess }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          model: {
                            value: _vm.editCatForm.birth_img,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "birth_img", $$v)
                            },
                            expression: "editCatForm.birth_img"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "全家福" } },
                      [
                        _c("Upload", {
                          attrs: {
                            reportType: "family_img",
                            file_url: _vm.editCatForm.family_img
                          },
                          on: { success: _vm.handleUploadFileSuccess }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          model: {
                            value: _vm.editCatForm.family_img,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "family_img", $$v)
                            },
                            expression: "editCatForm.family_img"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "其他图片列表" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 4 },
                            placeholder:
                              "请用英文逗号隔开图片地址，不要使用空格"
                          },
                          model: {
                            value: _vm.editCatForm.img_list,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "img_list", $$v)
                            },
                            expression: "editCatForm.img_list"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "仙喵视频" } },
                      [
                        _c("UploadVideo", {
                          attrs: {
                            reportType: "video_list",
                            file_url: _vm.editCatForm.video_list
                          },
                          on: { success: _vm.handleUploadFileSuccess }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          model: {
                            value: _vm.editCatForm.video_list,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "video_list", $$v)
                            },
                            expression: "editCatForm.video_list"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "家庭关系", name: "third" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "老爸" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { filterable: "", placeholder: "请选择" },
                            model: {
                              value: _vm.editCatForm.father_id,
                              callback: function($$v) {
                                _vm.$set(_vm.editCatForm, "father_id", $$v)
                              },
                              expression: "editCatForm.father_id"
                            }
                          },
                          _vm._l(_vm.catList, function(cat) {
                            return _c(
                              "el-option",
                              {
                                key: cat.id,
                                attrs: { label: cat.name, value: cat.id }
                              },
                              [
                                _c("span", { staticStyle: { float: "left" } }, [
                                  _vm._v(_vm._s(cat.name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      color: "#8492a6",
                                      "font-size": "13px"
                                    }
                                  },
                                  [_vm._v(_vm._s(cat.sex))]
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "老妈" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { filterable: "", placeholder: "请选择" },
                            model: {
                              value: _vm.editCatForm.mother_id,
                              callback: function($$v) {
                                _vm.$set(_vm.editCatForm, "mother_id", $$v)
                              },
                              expression: "editCatForm.mother_id"
                            }
                          },
                          _vm._l(_vm.catList, function(cat) {
                            return _c(
                              "el-option",
                              {
                                key: cat.id,
                                attrs: { label: cat.name, value: cat.id }
                              },
                              [
                                _c("span", { staticStyle: { float: "left" } }, [
                                  _vm._v(_vm._s(cat.name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      color: "#8492a6",
                                      "font-size": "13px"
                                    }
                                  },
                                  [_vm._v(_vm._s(cat.sex))]
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "兄弟姐妹" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              multiple: "",
                              filterable: "",
                              "allow-create": "",
                              "default-first-option": "",
                              placeholder: "请选择兄弟姐妹，支持名字搜索"
                            },
                            model: {
                              value: _vm.editCatForm.brother_id_list,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editCatForm,
                                  "brother_id_list",
                                  $$v
                                )
                              },
                              expression: "editCatForm.brother_id_list"
                            }
                          },
                          _vm._l(_vm.catList, function(cat) {
                            return _c("el-option", {
                              key: cat.id,
                              attrs: { label: cat.name, value: cat.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "预防记录", name: "fourth" } },
                  [
                    _vm._l(_vm.editCatForm.record_list, function(record) {
                      return _c(
                        "el-form-item",
                        { attrs: { label: "记录" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "95%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "选择 年/月/日"
                                },
                                model: {
                                  value: record.date,
                                  callback: function($$v) {
                                    _vm.$set(record, "date", $$v)
                                  },
                                  expression: "record.date"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("el-autocomplete", {
                                staticClass: "inline-input",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "fetch-suggestions": _vm.querySearch,
                                  placeholder: "请输入内容"
                                },
                                on: { select: _vm.handleSelect },
                                model: {
                                  value: record.text,
                                  callback: function($$v) {
                                    _vm.$set(record, "text", $$v)
                                  },
                                  expression: "record.text"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "新增记录" } },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "success",
                            icon: "el-icon-plus",
                            circle: ""
                          },
                          on: { click: _vm.addRecord }
                        })
                      ],
                      1
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "销售相关", name: "fifth" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "售价（原价）", prop: "price" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "输入数字即可" },
                          model: {
                            value: _vm.editCatForm.price,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "price", $$v)
                            },
                            expression: "editCatForm.price"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "定金", prop: "downpayment" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "输入数字即可" },
                          model: {
                            value: _vm.editCatForm.downpayment,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "downpayment", $$v)
                            },
                            expression: "editCatForm.downpayment"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "折扣价", prop: "discount" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "输入数字即可" },
                          model: {
                            value: _vm.editCatForm.discount,
                            callback: function($$v) {
                              _vm.$set(_vm.editCatForm, "discount", $$v)
                            },
                            expression: "editCatForm.discount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "伤病记录（未开放）", name: "sixth" } },
                  [_vm._v("伤病记录")]
                )
              ],
              1
            )
          ],
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.onCancel } }, [_vm._v("关闭")])
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }